import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import { Bar } from 'react-chartjs-2';
import { Peak } from './types';
import { createTimeline, generateTimeLabels } from './utils';

interface RideTimeDistributionChartProps {
  peaks: Peak[];
  startTime: string;
  endTime: string;
  interval: number;
}

const RideTimeDistributionChart: React.FC<RideTimeDistributionChartProps> = ({ peaks, startTime, endTime, interval }) => {
  const { t } = useTranslation('mapWizards');
  const times = generateTimeLabels(startTime, endTime, interval);
  const data = {
    labels: times,
    datasets: [
      {
        label: t('generateRides.rideTimeDistribution.datasetLabel'),
        data: createTimeline(times, peaks),
        backgroundColor: 'rgba(238, 115, 52, 1)',
        borderColor: 'rgba(238, 115, 52, 1)',
      },
    ],
  };
  const options = {
    scales: {
      x: { grid: { display: false } },
      y: { grid: { display: false }, beginAtZero: true },
    },
    plugins: { legend: { display: false } },
  };
  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="h6">{t('generateRides.rideTimeDistribution.title')}</Typography>
      <Typography variant="body2" sx={{ mb: 1 }}>
        {t('generateRides.rideTimeDistribution.description')}
      </Typography>
      <Bar data={data} options={options} />
    </Box>
  );
};

export default RideTimeDistributionChart; 